import {Component, Input} from "@angular/core";
import {DbServerErrors} from "../../../shared/interceptors/db-server-errors";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../shared/components/notifier/notification";
import {DbTextPipe} from "../../../shared/pipes/db-text.pipe";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {UserService} from '../../../user/user.service';
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {PaymentMethod} from "../../../user/payment-method";
import {UserSubscription} from "../../../user/user-subscription";
import {WorkspaceService} from "../../workspace.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../store";


@Component({
    selector: 'db-add-payment-method',
    templateUrl: './add-payment-method.component.html',
    styleUrls: ['./add-payment-method.component.scss'],
    standalone: false
})
export class AddPaymentMethodComponent extends DialogComponent<null, Boolean> {

  public loading: boolean = true;
  public loadingMessage: string;
  @Input() checkout: any;
  @Input() stripe: any;
  @Input() userSubscription?: UserSubscription;
  @Input() isPayPalProvider?: boolean;
  @Input() confirmPayPalPayment?: () => Promise<{ success: boolean; error?: string }>;

  public onLoadingChange(isLoading: boolean): void {
    this.loading = isLoading;
  }

  public onPaymentMethodSubmit (): void {
      this.result = true;
      this.close();
  }

}
